import React, {useEffect, useState} from 'react';
import AppForm from '../../../../../components/forms/AppForm';
import AppFormSelectField from '../../../../../components/forms/AppFormSelectField';
import {Column, Row} from '../../../../../components/layout';
import {addToWizard, setWizard} from '../../../../../store/actions';
import {strings} from '../../../../../util/strings';
import * as Yup from 'yup';
import colors from '../../../../../util/colors';
import './styles.scss';
import {
  AppFormCheckboxField,
  AppFormDatePickerField,
  AppFormField,
  AppFormSubmitButton,
} from '../../../../../components/forms';
import {
  today,
  createCoveragesMap,
  getDateInServerFormat,
  toDataUrl,
  toDataUrlAsync,
  appendFormData,
  recreateFilesFromRedux,
  getCurrencyCode,
} from '../../../../../util/utility';
import AppTextInput from '../../../../../components/input/app-text-input';
import {Icons} from '../../../../../util/icons';
import Icon from '../../../../../components/icon';
import * as fonts from '../../../../../util/fonts';
import {compose} from 'redux';
import {connect} from 'react-redux';
import AppSelectInput from '../../../../../components/input/app-select-input';
import {createGUID} from '../../../../../util/utility';
import AppErrorMessage from '../../../../../components/app-error-message';
import AppFilePreview from '../../../../../components/app-drap-drop-file-input/app-file-preview';
import ModalTemplate from '../../../../../components/modal';
import Header2 from '../../../../../components/headers/header2';
import AppDrapDropFileInput from '../../../../../components/app-drap-drop-file-input';
import moment from 'moment';
import {
  uriExpenseSubmitionToAdvSystem,
  uriIreneCoverages,
  uriMemberData,
} from '../../../../../api/endpoints';
import {get, post, postWithCustomHeaders, remove} from '../../../../../api/api';
import {useHistory} from 'react-router-dom';
import AppButton from '../../../../../components/app-button';
import {FieldArray} from 'formik';
import AppSpinner from '../../../../../components/app-spinner';

export interface ReimbursementDataProps {
  onSubmit(values: any): any;
  setValid(value: boolean): void;
  nextStep(): void;
  valid: boolean;
  wizard: any;
  setWizard(value: any): void;
  addToWizard(value: any): void;
  buStyles: any;
  selectedBu: any;
  labels: typeof strings.pt.createRefund;
  messageLabels: typeof strings.pt.messages;
  user: any;
  patients: any;
}

const expensesValidationSchema = Yup.object().shape({
  coverage: Yup.string().required(),
  medicalAct: Yup.string().required(),
  value: Yup.number().required().moreThan(0).positive(),
});

function ReimbursementData({
  valid,
  setValid,
  labels,
  messageLabels,
  wizard,
  setWizard,
  addToWizard,
  buStyles,
  selectedBu,
  user,
  patients,
}: ReimbursementDataProps) {
  const [submitting, setSubmitting] = useState(false);
  const [patient, setPatient] = useState('');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [patientOptions, setPatientOptions] = useState<any[]>([]);
  const [documentsFetch, setDocumentsFetch] = useState<any[]>([]);
  const [invoiceFile, setInvoiceFile] = useState<any[]>([]);
  const [files, setFiles] = useState<any[]>([]);
  const [expenses, setExpenses] = useState<any[]>([]);
  const [errorShow, setErrorShow] = useState(false);
  const [procsToValidate, setProcsToValidate] = useState<any[]>([]);
  const [expensesLabels, setExpensesLabels] = useState<Set<string>>(
    new Set([])
  );
  const [datePickerFloorError, setDatePicketFloorError] = useState(false);
  const [datePickerEmpty, setDatePickerEmpty] = useState(false);
  const [medicalAct, setMedicalAct] = useState('');
  const [expensesLabel, setExpensesLabel] = useState('');
  const [coveragesMap, setCoveragesMap] = useState<any>({});
  const [coverageOptions, setCoverageOptions] = useState<any[]>([]);
  const [validationSchema, setValidationSchema] = useState<any>(
    Yup.object().shape({
      patient: Yup.mixed().required(),
      dateOfOcurrence: Yup.date()
        .required(messageLabels?.requiredField)
        .nullable()
        .max(today(true))
        .min('1999-01-01'),
      noDocuments: !!files.find((elem) => elem.name === 'Informação Médica') //VER ISTO
        ? Yup.boolean().required().oneOf([true, false])
        : Yup.boolean().required().oneOf([true]),
      expenses: Yup.array().of(
        Yup.object().shape({
          coverage: Yup.string().required(),
          medicalAct: Yup.string().required(),
          value: Yup.number().required().moreThan(0),
        })
      ),
      termsAccepted: Yup.boolean().required().oneOf([true]),
    })
  );
  const [formikContext, setFormikContext] = useState<any>();
  const history = useHistory();

  const [hoverErrorIcons, setHoverErrorIcons] = useState<any>([]);
  const [hoverErrorDateOfOcurrence, setHoverErrorDateOfOcurrence] =
    useState(false);
  const [noDocuments, setNoDocuments] = useState(false);
  const dateLimit = new Date('JAN 01 1999');
  const submitDisableConditions =
    !valid || submitting || expenses.length === 0 || datePickerFloorError;

  const featureName = 'Reimbursement';

  useEffect(() => {
    var aux: any[] = [];
    expenses.forEach((element) => {
      // cloning the objects and removing any references
      var ob = Object.assign({}, element);
      aux.push(ob);
    });

    setHoverErrorIcons(aux);
  }, [expenses]);

  const defineOnMouseFunctions = (
    e: React.MouseEvent,
    fieldNamePar: string,
    index: number,
    valueError?: boolean,
    dateOfOcurrence?: boolean
  ) => {
    var elem: HTMLElement = e.target as HTMLElement;
    if (valueError) {
      var icon: HTMLElement = elem.nextSibling as HTMLElement;
      if (index > -1) defineIconFunctions(icon, fieldNamePar, index);
    }

    if (elem.tagName.includes('svg') || elem.tagName.includes('path')) {
      var icon: HTMLElement = elem as HTMLElement;
      if (index > -1) defineIconFunctions(icon, fieldNamePar, index);
      else if (dateOfOcurrence) {
        if (icon) {
          icon.onmouseover = function () {
            if (datePickerFloorError || datePickerEmpty)
              setHoverErrorDateOfOcurrence(true);
          };
          icon.onmouseout = function () {
            setHoverErrorDateOfOcurrence(false);
          };
        }
      }
    }
  };

  const defineIconFunctions = (
    icon: HTMLElement,
    fieldNamePar: any,
    index: number
  ) => {
    if (icon) {
      icon.onmouseover = function () {
        showErrorOnFieldHover(fieldNamePar, index, true);
      };
      icon.onmouseout = function () {
        showErrorOnFieldHover(fieldNamePar, index, false);
      };
    }
  };

  const showErrorOnFieldHover = (
    fieldNamePar: any,
    index: number,
    boolValue: boolean
  ) => {
    var aux: any[] = [];
    var changedAux: any[] = [];

    if (hoverErrorIcons !== undefined) {
      Object.keys(hoverErrorIcons).map((item: any, i) => {
        changedAux = hoverErrorIcons[index];
        changedAux[fieldNamePar] = boolValue;

        aux.push(
          i === index
            ? !aux.includes(hoverErrorIcons[index])
              ? hoverErrorIcons[index]
              : null
            : hoverErrorIcons[item]
        );
      });
      setHoverErrorIcons(aux);
    }
  };

  const createMedicalActOptions = (
    coverage: string,
    customCoveragesMap?: any
  ) => {
    const aux = customCoveragesMap ? customCoveragesMap : coveragesMap;
    return coverage !== ''
      ? aux && aux[`${coverage}`]
        ? aux[`${coverage}`].medicalActs.map((medicalAct: any) => ({
            value: medicalAct.procCode,
            label: medicalAct.procCodeDesc,
          }))
        : []
      : [];
  };

  const deleteProcess = async () => {
    setWizard({step: 0});
  };

  const updateExpensesLabels = (expenses: any[]) => {
    setExpensesLabels(
      new Set(
        expenses.map((elem) => {
          const coverage = coveragesMap[`${elem.coverage}`];
          if (coverage && coverage.medicalActs) {
            const medicalAct = coverage.medicalActs.find(
              (act: any) => act.procCode === elem.medicalAct
            );
            return medicalAct && medicalAct.msg;
          }
        })
      )
    );
  };

  useEffect(() => {
    window.addEventListener('mousemove', () => {});

    // returned function will be called on component unmount
    return () => {
      setWizard({});
      window.removeEventListener('mousemove', () => {});
    };
  }, []);

  const getBase64FromInvoice = async (invoiceFiles: any) => {
    return new Promise(async (resolve, reject) => {
      const newInvoiceFiles: any = [];
      await invoiceFiles.forEach(async (file: any) => {
        await toDataUrlAsync(file.preview)
          .then(async (base64: any) => {
            let newFile = await {...file, preview: base64};
            newInvoiceFiles.push(newFile);
            if (invoiceFiles.length === newInvoiceFiles.length) {
              resolve(newInvoiceFiles);
            }
          })
          .catch((err: any) => {
            reject(err.toString());
          });
      });
    });
  };

  useEffect(() => {
    const {files: reduxFiles} = wizard.attachFiles;
    const newFiles = recreateFilesFromRedux(reduxFiles);
    setInvoiceFile(newFiles);
  }, [wizard.attachFiles]);

  useEffect(() => {
    function getPatientOptions() {
      const patientsList = patients.patients;

      var patientsOpt: any[] = [];
      (patientsList as any).map((patient: any) => {
        if (
          selectedBu.famId === patient.famId &&
          selectedBu.buId === patient.buId
        )
          patientsOpt.push(patient);
      });

      setPatientOptions(
        (patientsOpt as any).map((patient: any) => {
          return {
            value: patient.memberName,
            label: patient.memberName,
          };
        })
      );
    }

    getPatientOptions();
  }, []);

  const getMemIdForBody = (patientName: any) => {
    let result = '';
    patients.patients.forEach((el: any) => {
      if (el.memberName === patientName) {
        result = el.memId;
      }
    });
    return result;
  };

  // get coverages/medicalActs map from backend
  async function getExpenses(buId: any, benNbr: any) {
    const medicalActs = wizard.invoiceValidation.atoMedicos;

    const response: any = await get(
      uriIreneCoverages(buId, benNbr),
      false,
      0,
      featureName
    );
    setProcsToValidate(response?.data?.items);
    const coveragesMap = createCoveragesMap(response?.data?.items);
    setCoveragesMap(coveragesMap);

    setCoverageOptions(
      Object.keys(coveragesMap).map((key) => {
        const coverage = coveragesMap[key];
        return {
          value: coverage.catCode,
          label: coverage.catCodeDesc,
        };
      })
    );

    const newExpenses = medicalActs.map((medicalAct: any) => ({
      id: createGUID(),
      coverage: medicalAct.coberturaCode,
      medicalAct: medicalAct.code,
      value: medicalAct.total,
      error: {},
    }));
    setExpenses(newExpenses);

    updateExpensesLabels(newExpenses);
  }

  useEffect(() => {
    getExpenses(patients.buId, patients.benNbr);
  }, []);

  useEffect(() => {
    setValidationSchema(
      Yup.object().shape({
        patient: Yup.mixed().required(),
        dateOfOcurrence: Yup.date().required().max(today(true)),
        noDocuments:
          expensesLabel !== ''
            ? files.find((elem) => elem.name === 'Informação Clínica')
              ? Yup.boolean().required().oneOf([false])
              : Yup.boolean().required().oneOf([true])
            : Yup.mixed(),
        expenses: Yup.array().of(
          Yup.object().shape({
            coverage: Yup.string().required(),
            medicalAct: Yup.string().required(),
            value: Yup.number().required().moreThan(0),
          })
        ),
        termsAccepted: Yup.boolean().required().oneOf([true]),
      })
    );
  }, [files, expensesLabel]);

  useEffect(() => {
    async function validateForm() {
      if (!!formikContext) {
        const result = await formikContext.validateForm();
        if (Object.keys(result).length > 0) {
          // Invalid form
          setValid(false);
        }
      }
    }

    validateForm();
  }, [validationSchema]);

  useEffect(() => {
    updateExpensesLabels(expenses);
    if (formikContext) {
      (formikContext as any).setFieldValue('expenses', expenses);
    }
  }, [expenses]);

  useEffect(() => {
    renderMedicalActsLabels();
  }, [expensesLabels]);

  const fetchDocumentBlobs = () => {
    var documentsFetchAux: any[] = [];
    wizard.invoiceValidation.documents.map(async (document: any) => {
      if (document.fileName)
        await fetch(document.fileName)
          .then((e) => {
            return e.blob();
          })
          .then((blob) => {
            let b: any = blob;
            b.lastModifiedDate = new Date();
            let name: string = document.fileName?.split('/');
            b.name = name[name.length - 1];
            var file = new File([b], name[name.length - 1]);
            documentsFetchAux.push(file);
          });
    });

    setDocumentsFetch(documentsFetchAux);
  };

  const handlePatientChange = (value: any) => {
    const newPatient = patients.patients.find(
      (el: any) => el.memberName === value
    );
    getExpenses(newPatient.buId, newPatient.benNbr);
  };

  useEffect(() => {
    fetchDocumentBlobs();
    const files = wizard.invoiceValidation.documents.map((document: any) => {
      const aux = (document.fileName as string)?.split('/');
      return {
        path: (aux && aux[aux.length - 1]) || document.fileName,
        preview: document.fileName,
        id: createGUID(),
        name: 'Fatura',
      };
    });
    setWizard({
      ...wizard,
      attachFiles: {
        ...wizard.attachFiles,
        files,
      },
    });
  }, []);

  const hasErrors = async (expenses: any[], index: number) => {
    try {
      await expensesValidationSchema.validate(expenses[index], {
        abortEarly: false,
      });
      expenses[index].error = {};
      setExpenses(expenses);
      return false;
    } catch (e: any) {
      let newError = {};
      e.inner.forEach((innerError: any) => {
        (newError as any)[innerError.path] = innerError.message;
      });
      expenses[index].error = newError;
      setExpenses(expenses);
      return newError;
    }
  };

  const handleDatePickerChange = (value: any) => {
    if (!value) {
      setDatePickerEmpty(true);
      setDatePicketFloorError(false);
    } else if (moment(value) < moment(dateLimit)) {
      setDatePicketFloorError(true);
      setDatePickerEmpty(false);
    } else {
      setDatePicketFloorError(false);
      setDatePickerEmpty(false);
    }
  };

  const updateExpense = async (index: number, field: string, value: any) => {
    let newExpenses = [...expenses];
    (newExpenses[index] as any)[field] = value;
    const expenseErrors = await hasErrors(newExpenses, index);
    if (expenseErrors) {
      newExpenses[index].error = expenseErrors;
      setExpenses(newExpenses);
      setValid(false);
    } else {
      setExpenses(newExpenses);
    }
  };

  const handleFormikContext = (formik: any) => {
    if (!!!formikContext || formik.errors !== (formikContext as any).errors) {
      setFormikContext(formik);
    }
  };

  const calculateTotalValue = () => {
    let totalValue: number = 0;
    let experience: number = 0;
    expenses.forEach((expense) => {
      if (!!expense.value) {
        totalValue += +expense.value;
        totalValue = Math.round((totalValue + Number.EPSILON) * 100) / 100;
      }
    });
    return totalValue;
  };

  const onDeleteInvoice = () => {
    setShowDeleteModal(true);
  };

  const onDelete = (id: string) => {
    let newFiles = [...files];
    newFiles = newFiles.filter((elem) => {
      if (elem.id !== id) {
        return true;
      } else {
        URL.revokeObjectURL(elem.preview);
        return false;
      }
    });
    setFiles(newFiles);
  };

  const renderMedicalActsLabels = () => {
    let expensesLabel: string = '';
    const expensesLabelsArray = Array.from(expensesLabels).filter(
      (elem) => !!elem && elem !== ''
    );
    expensesLabelsArray.forEach((elem: string, index: number) => {
      expensesLabel += elem;
      if (
        expensesLabelsArray.length > 1 &&
        index < expensesLabelsArray.length - 1
      ) {
        if (index === expensesLabelsArray.length - 2) {
          expensesLabel += ' e ';
        } else {
          expensesLabel += ', ';
        }
      } else {
        expensesLabel += '.';
      }
    });
    setExpensesLabel(expensesLabel);
  };

  const changeCheckbox = (value: boolean) => {
    setNoDocuments(value);
  };

  return (
    <div className="reimbersement-data-container">
      <AppForm
        className="patient-validation-form-container"
        initialValues={{
          patient: patients.memberName,
          dateOfOcurrence: wizard?.invoiceValidation?.docDate
            ? moment(wizard.invoiceValidation.docDate).isValid()
              ? moment(wizard.invoiceValidation.docDate).toDate()
              : null
            : null,
          noDocuments: false,
          expenses: expenses,
          termsAccepted: false,
        }}
        validationSchema={validationSchema}
        onValidation={(valid) => {
          setValid(valid);
        }}
        onChange={(values: any) => {
          if (values.patient !== patient) {
            setPatient(values.patient);
          }
          if (values.noDocuments !== noDocuments) {
            setNoDocuments(!noDocuments);
          }
        }}
        onSubmit={async (values) => {
          setSubmitting(true);
          let hasError = false;
          const {buId, memId, famId} = patients;

          const selectedContact: any = await get(
            uriMemberData(buId, memId, famId)
          );
          const clinicInfoDocs = files.filter(
            (elem) => elem.name === 'Informação Clínica'
          );

          var now = moment();
          var time = now.hour() + ':' + now.minutes();
          const dataSend = {
            patient: selectedContact.name,
            proceed: {
              procCodeList: expenses.map((expense) => ({
                procCode: expense.medicalAct,
                amtClaimed: expense.value,
                dos: getDateInServerFormat(values.dateOfOcurrence),
              })),
              processNumber: 'string',
            },
            expenses: expenses,
            expensesLabels: expensesLabels,
            dateTime: getDateInServerFormat(values.dateOfOcurrence),
            procedures: procsToValidate,
            currentTime: time,
            patientName: patient,
          };
          const newExpensesFinal: any[] = [];
          dataSend.procedures.map((procedure: any) => {
            dataSend.expenses.map((expense: any) => {
              if (
                procedure.catCode == expense.coverage &&
                procedure.procCode == expense.medicalAct
              ) {
                newExpensesFinal.push({
                  cover: procedure.catCodeDesc,
                  actoMedico: procedure.procCodeDesc,
                  amountclaimed: expense.value,
                  coverage: expense.coverage,
                  medicalAct: expense.medicalAct,
                  catName: procedure.catCodeDesc,
                });
              }
            });
          });
          var docs: any[] = [];
          clinicInfoDocs.map((document) =>
            docs.push({
              filename: document.path,
              filedata: document.preview,
            })
          );

          await getBase64FromInvoice(invoiceFile)
            .then((allFiles: any) => {
              allFiles.map((file: any) =>
                docs.push({
                  filename: file.path,
                  filedata: file.preview,
                })
              );
            })
            .catch((error: any) => {
              hasError = true;
              setErrorShow(true);
              setSubmitting(false);
            });

          if (hasError) return;

          const body = {
            pacientName: patient,
            buId: buId,
            memId: getMemIdForBody(patient),
            sessionId: wizard.attachFiles.sessionId,
            expenseDetails: {
              procCodeList: newExpensesFinal.map((expense) => ({
                medicalActName: expense.actoMedico,
                coverageName: expense.cover,
                procCode: expense.medicalAct,
                amtClaimed: expense.amountclaimed,
                dos: getDateInServerFormat(values.dateOfOcurrence),
              })),
            },
            username: user.sub,
            user: user.given_name + ' ' + user.family_name,
          };

          var formData = new FormData();

          formData = appendFormData(
            body.expenseDetails,
            'expenseDetails',
            formData
          );
          formData.append('pacientName', patient);
          formData.append('buId', buId);
          formData.append('memId', getMemIdForBody(patient));
          formData.append('sessionId', wizard.attachFiles.sessionId);

          // blobs from azure
          documentsFetch.forEach((doc) => {
            formData.append('documents', doc);
          });

          // attached files
          files.forEach((doc) => {
            formData.append('documents', doc.file);
          });

          formData.append('username', user.sub);
          formData.append('user', user.given_name + ' ' + user.family_name);
          try {
            await postWithCustomHeaders(
              uriExpenseSubmitionToAdvSystem(),
              formData
            );
            history.push('/historico-reembolsos/pedido-enviado', dataSend);
          } catch (e: any) {
            setErrorShow(true);
          } finally {
            setSubmitting(false);
          }
        }}>
        {!submitting && (
          <Row className="reimbursement-confirm-data">
            <p
              style={{
                ...fonts.ML,
                ...fonts.Bold,
                color: colors.black,
              }}
              className="reimbursement-data-subtitle-desktop">
              {labels?.createRefund_confirmData}
            </p>
            <p
              style={{
                ...fonts.ML,
                ...fonts.Bold,
                color: colors.black,
              }}
              className="reimbursement-data-subtitle-responsive">
              {labels?.createRefund_confirmDataResponsive}
            </p>
          </Row>
        )}
        {!submitting && (
          <Row className="reimbursement-data-firstrow">
            <Column
              className="reimbursement-data-firstrow-column"
              style={{
                background: 'linear-gradient(180deg, #F9F9F9 0%, #F0F0F0 100%)',
              }}>
              <Row className="reimbursement-data-firstrow-column-firstrow">
                <p style={{...fonts.SM}}>{labels?.createRefund_patient}*</p>
              </Row>
              <Row>
                <AppFormSelectField
                  inputStyle={{
                    ...fonts.Bold,
                    color: buStyles?.primaryColor || colors.blue,
                  }}
                  className="reimbursement-data-input w-100"
                  name={'patient'}
                  onChange={(value) => handlePatientChange(value)}
                  options={patientOptions}
                  handleFormikContext={(formik) =>
                    handleFormikContext(formik)
                  }></AppFormSelectField>
              </Row>
            </Column>

            <Column
              className="reimbursement-data-firstrow-column"
              style={{
                background: 'linear-gradient(180deg, #F9F9F9 0%, #F0F0F0 100%)',
              }}>
              <Row className="reimbursement-data-firstrow-column-firstrow">
                <p style={{...fonts.SM}}>
                  {labels?.createRefund_occurenceDate}*
                </p>
              </Row>
              <Row
                onMouseOver={(e) => {
                  defineOnMouseFunctions(
                    e,
                    'dateOfOcurrence',
                    -1,
                    undefined,
                    true
                  );
                }}
                style={{position: 'relative'}}>
                <AppFormDatePickerField
                  className="reimbursement-data-input"
                  name="dateOfOcurrence"
                  onChange={(value) => handleDatePickerChange(value)}
                  handleFormikContext={(formik) => {
                    if (
                      !!!formikContext ||
                      formik.errors !== (formikContext as any).errors
                    ) {
                      setFormikContext(formik);
                    }
                  }}></AppFormDatePickerField>
                {hoverErrorDateOfOcurrence && (
                  <AppErrorMessage
                    message={
                      datePickerFloorError
                        ? labels?.createRefund_date_limit
                        : messageLabels?.requiredField
                    }
                    className="reimbursement-ocurrence-error-message"
                  />
                )}
                {datePickerFloorError && (
                  <Icon
                    width="24"
                    height="24"
                    className="date-picker-error-icon"
                    name={Icons.ALERT_PROBLEM}
                    color={colors.alertRed}
                  />
                )}
              </Row>
            </Column>
            <Column
              className="reimbursement-data-firstrow-column reimbursement-data-file-preview"
              style={{
                background: 'linear-gradient(180deg, #F9F9F9 0%, #F0F0F0 100%)',
              }}>
              {invoiceFile.length > 0 && (
                <AppFilePreview
                  displayQuantity={true}
                  name="Fatura"
                  deleteAll
                  file={invoiceFile[0]}
                  files={invoiceFile}
                  onDelete={onDeleteInvoice}
                  scope="createRefund"
                />
              )}
            </Column>
          </Row>
        )}

        {!submitting && (
          <Column
            className="reimbursement-data-secondrow p-4"
            style={{
              background: 'linear-gradient(180deg, #F9F9F9 0%, #F0F0F0 100%)',
            }}>
            <FieldArray
              name="expenses"
              render={(arrayHelpers) => {
                if (expenses.length > 0) {
                  return expenses.map((expense) => {
                    const index = expenses.indexOf(expense);
                    return (
                      <Column>
                        <Row className="reimbursement-data-inputs m-0">
                          <Column
                            className="reimbursement-data-header-cobertura"
                            style={{position: 'relative'}}>
                            {(expense.error as any).coverage &&
                              hoverErrorIcons[index]?.coverage === true && (
                                <AppErrorMessage
                                  message={labels?.createRefund_invalidInput}
                                  className="reimbursement-coverage-error-message"
                                />
                              )}
                            <Row>
                              <p className="m-0" style={{...fonts.SM}}>
                                {labels?.createRefund_coverage}*
                              </p>
                            </Row>
                            <Row
                              onMouseOver={(e) => {
                                defineOnMouseFunctions(e, 'coverage', index);
                              }}>
                              <AppFormSelectField
                                value={expense.coverage}
                                onChange={async (value: any) => {
                                  await updateExpense(index, 'coverage', value);
                                  let newExpenses = [...expenses];
                                  newExpenses[
                                    newExpenses.indexOf(expense)
                                  ].medicalAct = '';
                                  setExpenses(newExpenses);
                                  if (
                                    createMedicalActOptions(expense.coverage)
                                      .length === 1
                                  ) {
                                    await updateExpense(
                                      index,
                                      'medicalAct',
                                      createMedicalActOptions(
                                        expense.coverage
                                      )[0].value
                                    );
                                    (formikContext as any).setFieldValue(
                                      'medicalAct',
                                      ''
                                    );
                                  }
                                  (formikContext as any).setFieldValue(
                                    'coverage',
                                    ''
                                  );
                                }}
                                className="reimbursement-data-input"
                                options={coverageOptions}
                                error={
                                  (expense.error as any).coverage ||
                                  !expense.coverage
                                }
                                name={'coverage'}
                                inputStyle={{color: buStyles?.primaryColor}}
                                handleFormikContext={(formik) => {
                                  if (!!!formikContext) {
                                    setFormikContext(formik);
                                  }
                                }}
                              />
                            </Row>
                          </Column>

                          <Row className="reimbursement-data-header-others">
                            <Column
                              className="reimbursement-data-header-atomedico"
                              style={{position: 'relative'}}>
                              {(expense.error as any).medicalAct &&
                                hoverErrorIcons[index]?.medicalAct === true && (
                                  <AppErrorMessage
                                    message={labels?.createRefund_invalidInput}
                                    className="reimbursement-coverage-error-message"
                                  />
                                )}
                              <Row>
                                {' '}
                                <p
                                  className="reimbursement-data-header"
                                  style={{...fonts.SM}}>
                                  {labels?.createRefund_medicalAct}*
                                </p>
                              </Row>
                              <Row
                                onMouseOver={(e) => {
                                  defineOnMouseFunctions(
                                    e,
                                    'medicalAct',
                                    index
                                  );
                                }}>
                                <AppFormSelectField
                                  value={expense.medicalAct || ''}
                                  onChange={async (value: any) => {
                                    await updateExpense(
                                      index,
                                      'medicalAct',
                                      value
                                    );
                                    (formikContext as any).setFieldValue(
                                      'medicalAct',
                                      ''
                                    );
                                  }}
                                  className="reimbursement-data-input w-100"
                                  options={createMedicalActOptions(
                                    expense.coverage
                                  )}
                                  error={
                                    (expense.error as any).medicalAct ||
                                    (!expense.medicalAct &&
                                      createMedicalActOptions(expense.coverage)
                                        .length !== 1)
                                  }
                                  name={'medicalAct'}
                                  inputStyle={{color: buStyles?.primaryColor}}
                                  handleFormikContext={(formik) => {
                                    if (!!!formikContext) {
                                      setFormikContext(formik);
                                    }
                                  }}
                                />
                              </Row>
                            </Column>

                            <Column
                              className="reimbursement-data-header"
                              style={{position: 'relative'}}>
                              {(expense.error as any).value &&
                                hoverErrorIcons[index]?.value === true && (
                                  <AppErrorMessage
                                    message={labels?.createRefund_invalidValue}
                                    className="reimbursement-error-message"
                                  />
                                )}
                              <Row>
                                <p
                                  className="reimbursement-data-header"
                                  style={{...fonts.SM}}>
                                  {labels?.createRefund_value}*
                                </p>
                              </Row>
                              <Row className="input-field">
                                <AppFormField
                                  value={expense.value}
                                  onChange={async (value: any) => {
                                    if (
                                      !value ||
                                      /^(\d+[.]?\d{0,2})$/gm.test(value)
                                    ) {
                                      await updateExpense(
                                        index,
                                        'value',
                                        value
                                      );
                                    }
                                  }}
                                  className="reimbursement-data-input-value"
                                  name={'value'}
                                  error={
                                    (expense.error as any).value ||
                                    !expense.value
                                  }
                                  handleFormikContext={(formik) => {
                                    if (!!!formikContext) {
                                      setFormikContext(formik);
                                    }
                                  }}
                                  onMouseOver={(e) => {
                                    defineOnMouseFunctions(
                                      e,
                                      'value',
                                      index,
                                      true
                                    );
                                  }}
                                  showErrorMessage={false}
                                />
                              </Row>
                            </Column>
                          </Row>
                          <Column className="reimbursement-data-header-icon">
                            <Icon
                              onClick={() => {
                                let newExpenses = [...expenses];
                                newExpenses.splice(index, 1);
                                setExpenses(newExpenses);
                              }}
                              className="delete-icon"
                              name={Icons.CLOSE_CIRCLE}
                              color={colors.black}></Icon>
                          </Column>
                        </Row>

                        <Row className="reimbursement-data-white-row"></Row>
                      </Column>
                    );
                  });
                } else {
                  let newExpenses = [...expenses];
                  newExpenses.push({
                    id: createGUID(),
                    coverage: '',
                    medicalAct: '',
                    error: {},
                  });
                  setExpenses(newExpenses);
                  return null;
                }
              }}
            />
            <Row
              className="reimbursement-data-lastrow"
              style={{backgroundColor: colors.backgroundGrey}}>
              <Column className="reimbursement-data-lastrow-column-first"></Column>

              <Column className="reimbursement-data-lastrow-column-second">
                <Row className="reimbursement-data-lastrow-column-second-row m-0">
                  <div
                    style={{
                      ...fonts.M,
                      ...fonts.Bold,
                      color: colors.black,
                    }}>
                    {labels?.createRefund_totalValue}
                  </div>
                </Row>
              </Column>
              <Column className="reimbursement-data-lastrow-column-third">
                <Row className="justify-content-end m-0">
                  <div
                    style={{
                      ...fonts.ML,
                      ...fonts.Bold,
                      color: colors.black,
                    }}>
                    {calculateTotalValue()}{' '}
                    {getCurrencyCode(expenses[0].currency, 'createRefund')}
                  </div>
                </Row>
              </Column>
            </Row>
            {/* /> */}
          </Column>
        )}
        {!submitting && (
          <Row className="reimbursement-data-submit-row">
            <button className="reimbursement-data-submit-button">
              <Row>
                <Icon
                  name={Icons.PLUS}
                  width={'26'}
                  height={'26'}
                  strokeWidth={'0.5'}
                  style={{
                    ...fonts.M,
                    color: buStyles?.primaryColor || colors.blue,
                  }}></Icon>
                <p
                  style={{
                    ...fonts.MM,
                    ...fonts.Bold,
                    color: buStyles?.primaryColor || colors.blue,
                  }}
                  onClick={() => {
                    let newExpenses = [...expenses];
                    newExpenses.push({
                      id: createGUID(),
                      coverage: '',
                      medicalAct: '',
                      error: {},
                    });
                    setExpenses(newExpenses);
                    (formikContext as any).setFieldValue('coverage', '');
                    (formikContext as any).setFieldValue('medicalAct', '');
                  }}>
                  {labels?.createRefund_addInformation}
                </p>
              </Row>
            </button>
          </Row>
        )}
        {!submitting && (
          <Column className="attach-files-container attach-files-container-reimbursement-request-confirm">
            <Header2
              className="attach-files-title"
              style={{...fonts.L, ...fonts.Medium, color: colors.black}}>
              {labels?.createRefund_addClinicInfo}
            </Header2>
            <Row className="reimbursement-data-add-files-subtitle">
              {files.length <= 0 && expensesLabel !== '' && !noDocuments && (
                <Icon
                  width="24"
                  height="24"
                  className="attach-files-error-icon"
                  name={Icons.ALERT_PROBLEM}
                  color={colors.alertRed}
                />
              )}
              <span
                style={
                  files.length > 0 || noDocuments
                    ? {color: colors.black}
                    : {color: colors.alertRed}
                }>
                {expensesLabel !== '' &&
                  `${labels?.createRefund_include} ${expensesLabel}`}
              </span>
            </Row>
            {files.length > 0 && (
              <Row className="app-row">
                <div className="reimbersement-step3-files-container reimbursement-data-attachfilerow reimbursement-data-file-preview">
                  {files.map((item: any) => (
                    <AppFilePreview
                      displayQuantity={false}
                      name={labels?.createRefund_clinicInfo}
                      // deleteAll
                      file={item}
                      files={files}
                      onDelete={() => onDelete(item.id)}
                      scope="createRefund"
                    />
                  ))}
                </div>
              </Row>
            )}
            <div className="app-drag-drop-container">
              <AppDrapDropFileInput
                checkbox={expensesLabel !== ''}
                files={files}
                setFiles={setFiles}
                hidePreviews={true}
                newFilesName={'Informação Clínica'}
                name={'noDocuments'}
              />
            </div>
            {/* </Row> */}
            <div
              style={{
                textAlign: 'left',
                marginTop: 15,
              }}>
              <AppFormCheckboxField
                style={{justifyContent: 'left', paddingTop: 30}}
                name={'termsAccepted'}
                label={
                  <span style={{...fonts.SM}}>
                    <p>{labels?.createRefund_checkConsent}</p>
                    <p>{labels?.createRefund_checkConsentEnd}</p>
                  </span>
                }
              />
              <div
                style={{
                  textAlign: 'left',
                  marginTop: 15,
                  marginLeft: 25,
                }}>
                <Row style={{...fonts.SM}}>
                  {labels?.createRefund_requiredFields}
                </Row>
              </div>
            </div>
            <Row className="attach-files-confirm-button-row">
              <AppFormSubmitButton
                className="attach-files-confirm-button"
                disabled={submitDisableConditions}
                title={labels?.createRefund_selectFilesConfirmAndSendButtonText}
              />
            </Row>
          </Column>
        )}
        {submitting && <AppSpinner />}
        <ModalTemplate
          show={showDeleteModal}
          className="delete-popup-content"
          onHide={() => setShowDeleteModal(false)}
          cross={true}
          hideFooter={true}
          size="lg">
          <Column>
            <div className="delete-popup-icon">
              <Icon
                className="errorPopup-icon"
                name={Icons.ALERT_PROBLEM}
                width="18"
                height="25"
                color={colors.alertRed}
              />
            </div>
            <p style={{...fonts.MM, ...fonts.Bold, color: colors.alertRed}}>
              {labels?.createRefund_removeInvoiceTitle}
            </p>
            <p
              style={{
                ...fonts.MM,
                color: colors.black,
                marginRight: '20px',
                marginLeft: '20px',
              }}>
              {labels?.createRefund_removeInvoiceDescription}
            </p>
          </Column>
          <Row className="errorPopup-button">
            <AppButton
              className="health-data-button-yes"
              onClick={() => {
                deleteProcess();
              }}
              variant="secondary">
              {labels?.createRefund_removeInvoiceYes}
            </AppButton>
            <AppButton
              className="health-data-button-no"
              onClick={() => {
                setShowDeleteModal(false);
              }}
              variant="secondary">
              {labels?.createRefund_removeInvoiceNo}
            </AppButton>
          </Row>
        </ModalTemplate>
        {errorShow && (
          <ModalTemplate
            type="error"
            show={errorShow}
            hideFooter={true}
            onHide={() => {
              setErrorShow(false);
            }}
            cross={true}>
            <p style={{color: colors.black, fontWeight: 'bold'}}>
              {labels?.createRefund_errorOnReading}
            </p>
            <p>{labels?.createRefund_tryLater}</p>
            <Row>
              <AppButton
                onClick={() => {
                  setErrorShow(false);
                }}
                variant="secondary"
                className="talk-with-us-modal-button">
                {labels?.createRefund_popupConfirm}
              </AppButton>
            </Row>
          </ModalTemplate>
        )}
      </AppForm>
    </div>
  );
}
const mapStateToProps = ({
  user,
  wizard,
  strings,
  globalStyles,
  selectedBu,
  patients,
}: any) => ({
  user: user.value,
  wizard: wizard.value,
  labels: strings.value.pt.createRefund,
  messageLabels: strings.value.pt.messages,
  buStyles: globalStyles.value,
  selectedBu: selectedBu.value,
  patients: patients.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  addToWizard: (value: any) => dispatch(addToWizard(value)),
  setWizard: (value: any) => dispatch(setWizard(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(ReimbursementData)
);
